import { useEffect } from "react";
import { siteConfig } from "@/lib/site-config";
import { useDeferUntilInteraction } from "@/hooks/use-defer-interaction";

/**
 * Loads the LeadConnector chat widget only after the first user interaction.
 * The loader pulls in a large bundle that otherwise inflates TBT / unused JS
 * on initial load. Mounted once at the app root.
 */
const ThirdPartyWidgets = () => {
  const ready = useDeferUntilInteraction();

  useEffect(() => {
    if (!ready) return;
    const scriptId = "lc-chat-widget-loader";
    if (document.getElementById(scriptId)) return;

    const s = document.createElement("script");
    s.id = scriptId;
    s.src = siteConfig.widgets.chatLoaderSrc;
    s.async = true;
    s.setAttribute("data-resources-url", siteConfig.widgets.chatResourcesUrl);
    s.setAttribute("data-widget-id", siteConfig.widgets.chatWidgetId);
    document.body.appendChild(s);
  }, [ready]);

  return null;
};

export default ThirdPartyWidgets;
